import { AnyIfEmpty } from 'react-redux';
import {
    ADD_TOUR_EXPERIENCE_MESSAGE_REQUEST,
    ADD_TOUR_EXPERIENCE_MESSAGE_SUCCESS,
    ADD_TOUR_EXPERIENCE_MESSAGE_FAILURE,
    GET_TOUR_EXPERIENCE_MESSAGE_REQUEST,
    GET_TOUR_EXPERIENCE_MESSAGE_SUCCESS,
    GET_TOUR_EXPERIENCE_MESSAGE_FAILURE,
    EDIT_TOUR_EXPERIENCE_MESSAGE_REQUEST,
    EDIT_TOUR_EXPERIENCE_MESSAGE_SUCCESS,
    EDIT_TOUR_EXPERIENCE_MESSAGE_FAILURE,
    DELETE_TOUR_EXPERIENCE_MESSAGE_REQUEST,
    DELETE_TOUR_EXPERIENCE_MESSAGE_SUCCESS,
    DELETE_TOUR_EXPERIENCE_MESSAGE_FAILURE,
    REMOVE_PREVIOS_TOUR_DATA,
} from '../constants/tourExperience.constants';

const initialState = {
    loading: false,
    data: [],
    errorMsg: '',
};
export const tourExperienceReducer = (state = initialState, action: AnyIfEmpty<object>) => {
    switch (action.type) {
        case ADD_TOUR_EXPERIENCE_MESSAGE_REQUEST:
            return {
                ...state,
                loading: true,
                data: [],
            };
        case ADD_TOUR_EXPERIENCE_MESSAGE_SUCCESS:
            return {
                ...state,
                loading: false,
            };
        case ADD_TOUR_EXPERIENCE_MESSAGE_FAILURE:
            return {
                ...state,
                loading: false,
                errorMsg: action.payload,
            };
        case REMOVE_PREVIOS_TOUR_DATA:
            return {
                ...state,
                loading: false,
                data: [],
                errorMsg: '',
            };

        case GET_TOUR_EXPERIENCE_MESSAGE_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case GET_TOUR_EXPERIENCE_MESSAGE_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload,
            };
        case GET_TOUR_EXPERIENCE_MESSAGE_FAILURE:
            return {
                ...state,
                loading: false,
                errorMsg: action.payload,
            };

        case EDIT_TOUR_EXPERIENCE_MESSAGE_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case EDIT_TOUR_EXPERIENCE_MESSAGE_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload,
            };
        case EDIT_TOUR_EXPERIENCE_MESSAGE_FAILURE:
            return {
                ...state,
                loading: false,
                errorMsg: action.payload,
            };
        case DELETE_TOUR_EXPERIENCE_MESSAGE_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case DELETE_TOUR_EXPERIENCE_MESSAGE_SUCCESS:
            return {
                ...state,
                loading: false,
                errorMsg: action.payload,
            };
        case DELETE_TOUR_EXPERIENCE_MESSAGE_FAILURE:
            return {
                ...state,
                loading: false,
                errorMsg: action.payload,
            };

        default:
            return state;
    }
};
